import { useTranslation } from 'react-i18next';
import { Admission, ADMISSION_TYPE_INVITATION } from '@domain/admission';
import { Divider } from '@tremor/react';
import { calculateAdmissionPrice } from '@utils/calculate-booking-price';
import { formatNumber } from '@utils/format-number/format-number';
import classNames from 'classnames';

export interface AdmissionSummaryProps {
  offer: Admission;
  quantity: number;
  name: string;
}
export const AdmissionSummary = ({ offer, name, quantity }: AdmissionSummaryProps) => {
  const { t, i18n } = useTranslation();
  const formatName = quantity > 1 ? `${quantity} x ${name}` : name;
  const isInvitation = offer.admissionType === ADMISSION_TYPE_INVITATION;
  if (offer.price.amount === 0) {
    return (
      <>
        <p
          className={classNames('text-primary text-subtitle-m text-left', {
            'col-span-full': !isInvitation,
          })}>
          {isInvitation ? t('invitations:guests') : t('offers:tabAdmission')}
        </p>
        {isInvitation && <p className='text-primary text-subtitle-m text-right'>{t('invitations:pax')}</p>}
        <p className='text-secondary text-body-m text-left line-clamp-1 dark:text-gray-500'>{name}</p>
        <p className='text-secondary text-body-m text-right dark:text-gray-500'>{quantity}</p>
      </>
    );
  }
  return (
    <>
      <p
        className={classNames('text-primary text-subtitle-m text-left', {
          'col-span-full': !isInvitation,
        })}>
        {isInvitation ? t('invitations:guests') : t('offers:tabAdmission')}
      </p>
      <p className='text-secondary text-body-s sm:text-body-m text-left truncate'>{formatName}</p>
      <p className='text-secondary text-body-s sm:text-body-m text-right '>
        {formatNumber({
          number: offer.price.amount,
          locale: i18n.language,
          currency: offer.price.currency,
        })}
      </p>
      {quantity > 1 && (
        <>
          <Divider className='col-span-full py-0 mt-1 mb-0' />
          <p className='text-tertiary text-subtitle-m text-left'>{t('offers:subtotal')}</p>
          <p className='text-tertiary text-subtitle-m text-right'>
            {formatNumber({
              number: calculateAdmissionPrice({ offer, quantity }),
              locale: i18n.language,
              currency: offer.price.currency,
            })}
          </p>
        </>
      )}
    </>
  );
};
